/**
 * Textilstudio-bundle i varukorgen.
 *
 * Möbel + tyg ligger som två line items som delar propertyn _bundle.
 * snippets/cart-item.liquid ritar dem som en rad och döljer tygraden, så
 * "ta bort" på den raden måste nolla BÅDA raderna, annars blir tyget kvar
 * ensamt i varukorgen.
 *
 * Delegerar på document eftersom cart-drawern rear om sitt innehåll från
 * /cart?view=ajax varje gång varukorgen ändras. Samma kod täcker därför
 * både varukorgssidan och drawern.
 */
import { createDebugger } from '~/scripts/utils/debug.js';

const debug = createDebugger('cart-bundle', false);

const SELECTOR = '[data-bundle-remove]';

async function removeBundle(bundleId, btn) {
    debug.log('removing bundle', bundleId);
    btn.disabled = true;

    const cart = await fetch('/cart.js', { headers: { Accept: 'application/json' } }).then((r) =>
        r.ok ? r.json() : null
    );
    if (!cart) throw new Error('cart.js failed');

    // Nolla varje rad som bär samma _bundle. Nycklarna, inte radnumren, eftersom
    // radnumren flyttar sig så fort den första raden försvinner.
    const updates = {};
    (cart.items || []).forEach((item) => {
        const props = item.properties || {};
        if (props._bundle === bundleId) updates[item.key] = 0;
    });

    if (!Object.keys(updates).length) {
        debug.warn('no lines matched', bundleId);
        btn.disabled = false;
        return;
    }

    const r = await fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ updates })
    });
    if (!r.ok) throw new Error('update ' + r.status);

    // I drawern räcker det att be temat rita om. På varukorgssidan finns ingen
    // sådan hook, så där laddas sidan om.
    const drawer = window.theme && window.theme.CartDrawer;
    if (drawer && typeof drawer.buildCart === 'function') {
        drawer.buildCart();
        document.dispatchEvent(new CustomEvent('cart:build', { bubbles: true }));
    } else {
        window.location.reload();
    }
}

document.addEventListener('click', (e) => {
    const btn = e.target.closest(SELECTOR);
    if (!btn) return;
    e.preventDefault();

    const bundleId = btn.getAttribute('data-bundle-remove');
    if (!bundleId) return;

    removeBundle(bundleId, btn).catch((err) => {
        debug.error('bundle remove failed', err);
        btn.disabled = false;
        // Hellre en omladdning än en varukorg som ser fel ut mot vad servern har.
        window.location.reload();
    });
});
